import React, { useState, useEffect } from "react";
import { Alert, Table, Button, Container, Spinner, Form, Pagination } from "react-bootstrap";
import userService from "../services/user.service";  // Adjust based on your service path

const showURI= process.env.REACT_APP_API_URL;

const InvoiceManagerCustomer = () => {
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(false);
  const [apiErrors, setApiErrors] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [sortField, setSortField] = useState("invoice_id");
  const [sortOrder, setSortOrder] = useState("asc");
  const [selectedInvoiceId, setSelectedInvoiceId] = useState(null);  // State to hold selected invoice ID for PDF viewer
  const [showPDF, setShowPDF] = useState(false);  // State to manage PDF viewer visibility
  const seller_id = 1;  // Replace with the actual seller_id you want to filter by

  useEffect(() => {
    loadInvoices();
  }, [currentPage, searchTerm, sortField, sortOrder]);

  const loadInvoices = async () => {
    setApiErrors("");
    setLoading(true);
    try {
      const response = await userService.getInvoicesCustomer({
        page: currentPage,
        search: searchTerm,
        sort: sortField,
        order: sortOrder,
        seller_id: seller_id,  // Pass seller_id to filter invoices
      });
      setInvoices(response.data.invoices);  // Adjust based on your response structure
      setTotalPages(response.data.totalPages);
    } catch (error) {
      setApiErrors("Die Rechnungen konnten nicht geladen werden.");
    } finally {
      setLoading(false);
    }
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1); // Reset to the first page when searching
  };

  const handleSortChange = (field) => {
    const newSortOrder = sortField === field && sortOrder === "asc" ? "desc" : "asc";
    setSortField(field);
    setSortOrder(newSortOrder);
  };

  const downloadInvoice = async (invoiceId) => {
    try {
      const response = await userService.downloadInvoiceCustomer(invoiceId);  // API call to download the invoice
      const blob = new Blob([response.data], { type: "application/pdf" });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `invoice_${invoiceId}.pdf`;
      link.click();
    } catch (error) {
      setApiErrors("Die Rechnung konnte nicht heruntergeladen werden.");
    }
  };


  const viewInvoicePDF = (invoiceId) => {
    const pdfUrl = `${showURI}invoicescustomer/pdf/${invoiceId}`;
    window.open(pdfUrl, '_blank');  // Opens the PDF in a new tab
};
  const OviewInvoicePDF = (invoiceId) => {
    setSelectedInvoiceId(invoiceId);  // Set the selected invoice ID
    setShowPDF(true);  // Show the PDF viewer
  };

  const closePDFViewer = () => {
    setShowPDF(false);  // Hide the PDF viewer
    setSelectedInvoiceId(null);  // Clear the selected invoice ID
  };

  return (
    <Container>
      <h1>Meine Rechnungen</h1>
      {apiErrors && <Alert variant="danger">{apiErrors}</Alert>}
      <Form.Group controlId="searchInvoices">
        <Form.Label>Suche nach Rechnungsnummer</Form.Label>
        <Form.Control
          type="text"
          placeholder="Suchen …"
          value={searchTerm}
          onChange={handleSearchChange}
        />
      </Form.Group>
      {loading && <Spinner animation="border" />}
      <Table striped bordered hover>
        <thead>
          <tr>
            <th onClick={() => handleSortChange("invoice_id")}>Rechnungsnummer</th>
            <th onClick={() => handleSortChange("buyer_id")}>Käufernummer</th>
            <th onClick={() => handleSortChange("seller_id")}>Verkäufernummer</th>
            <th onClick={() => handleSortChange("invoice_total")}>Netto</th>
            <th onClick={() => handleSortChange("tax")}>Steuer</th>
            <th onClick={() => handleSortChange("invoice_brut_total")}>Brutto</th>
            <th onClick={() => handleSortChange("invoice_date")}>Rechnungsdatum</th>
            <th>Aktionen</th>
          </tr>
        </thead>
        <tbody>
          {invoices.length > 0 ? (
            invoices.map((invoice) => (
              <tr key={invoice.invoice_id}>
                <td>{invoice.invoice_id}</td>
                <td>{invoice.buyer_id}</td>
                <td>{invoice.seller_id}</td>
                <td>{invoice.invoice_total}</td>
                <td>{invoice.tax}</td>
                <td>{invoice.invoice_brut_total}</td>
                <td>{new Date(invoice.invoice_date).toLocaleDateString("de-DE")}</td>
                <td>
                  <Button
                    variant="info"
                    onClick={() => viewInvoicePDF(invoice.invoice_id)}
                  >
                    PDF anzeigen
                  </Button>
                  <Button
                    variant="primary"
                    onClick={() => downloadInvoice(invoice.invoice_id)}
                  >
                    Herunterladen
                  </Button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="8" className="text-center">Keine Rechnungen vorhanden.</td>
            </tr>
          )}
        </tbody>
      </Table>
      <Pagination>
        {[...Array(totalPages)].map((_, index) => (
          <Pagination.Item
            key={index}
            active={index + 1 === currentPage}
            onClick={() => setCurrentPage(index + 1)}
          >
            {index + 1}
          </Pagination.Item>
        ))}
      </Pagination>

      {showPDF && (
  <div className="pdf-viewer">
    <h2>PDF-Ansicht</h2>
    <p>Die PDF-Datei wird in einem neuen Tab geöffnet …</p>
    <Button variant="secondary" onClick={closePDFViewer}>
      Schließen
    </Button>
  </div>
      
      )}
    </Container>
  );
};

export default InvoiceManagerCustomer;
